import React from 'react';

const COLORS = ['#E74C3C', '#3498DB', '#2ECC71', '#F39C12', '#9B59B6'];

export default function BoxSidebar({ boxes, annotatorName }) {
  return (
    <div style={styles.wrap}>
      <div style={styles.header}>
        <h3 style={styles.title}>Annotations</h3>
        {annotatorName && (
          <span style={styles.annotator}>by {annotatorName}</span>
        )}
      </div>

      {!boxes || boxes.length === 0 ? (
        <p style={styles.empty}>No bounding boxes in this annotation.</p>
      ) : (
        <ul style={styles.list}>
          {boxes.map((box, i) => (
            <li key={i} style={styles.item}>
              <span style={{ ...styles.dot, background: COLORS[i % COLORS.length] }} />
              <div style={styles.info}>
                <span style={styles.label}>{box.label}</span>
                <span style={styles.coords}>
                  {(box.x * 100).toFixed(1)}%, {(box.y * 100).toFixed(1)}%
                  &nbsp;·&nbsp;
                  {(box.w * 100).toFixed(1)}% × {(box.h * 100).toFixed(1)}%
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

const styles = {
  wrap: { display: 'flex', flexDirection: 'column', gap: '0.75rem' },
  header: { display: 'flex', flexDirection: 'column', gap: '2px' },
  title: { margin: 0, color: '#e0e0e0', fontSize: '1rem', fontWeight: 600 },
  annotator: { color: '#64748b', fontSize: '0.8rem' },
  empty: { color: '#64748b', fontSize: '0.82rem', margin: 0 },
  list: { listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '6px' },
  item: {
    display: 'flex', alignItems: 'flex-start', gap: '8px',
    background: '#0f172a', borderRadius: '6px', padding: '7px 9px',
  },
  dot: { width: '10px', height: '10px', borderRadius: '50%', flexShrink: 0, marginTop: '3px' },
  info: { display: 'flex', flexDirection: 'column', gap: '2px', minWidth: 0 },
  label: { color: '#e2e8f0', fontSize: '0.85rem', fontWeight: 600 },
  coords: { color: '#64748b', fontSize: '0.7rem' },
};
